import {
  ApiRemoveGiftCardFromCartRequestedAction,
  apiRemoveGiftCardFromCartFailed,
  apiRemoveGiftCardFromCartSucceeded
} from '@spa/lib/store/api/cart/removeGiftCardFromCartApi';
import { call, put } from 'typed-redux-saga';
import removeGiftCardFromCartAction, {
  RemoveGiftCardFromCartActionInput,
  RemoveGiftCardFromCartActionResult
} from '@spa/lib/actions/cart/removeGiftCardFromCartAction';

function* removeGiftCardFromCartSaga({
  payload: { cartId, parentActionId, actionId: requestedActionId }
}: ApiRemoveGiftCardFromCartRequestedAction): Generator {
  try {
    const input: RemoveGiftCardFromCartActionInput = { cartId };
    const { result }: RemoveGiftCardFromCartActionResult = yield* call(
      removeGiftCardFromCartAction,
      'removeGiftCardFromCartAction',
      input
    );

    yield* put(
      apiRemoveGiftCardFromCartSucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId
      })
    );
  } catch {
    yield* put(
      apiRemoveGiftCardFromCartFailed({
        requestedActionId,
        parentActionId
      })
    );
  }
}

export default removeGiftCardFromCartSaga;
